module.exports = __webpack_public_path__ + "img/imgicon.d8f5caba.png";